import React from "react";
// import { useSelector } from "react-redux";
import Input from "../../../../components/inputs/inputs";
// import Button from "../../../../components/buttons/buttons";
// import { Beat } from "../../../../plugins/spinners.plugin";

export default function ShippersRate2({
  handleChange,
  data,
  handleSubmit,
  submitted,
  setData,
}) {
  // const { updating } = useSelector((state) => state.shipper);
  const {
    weight_limit_by_kilogram,
    base_fee_per_kilogram,
    vat_percentage,
    discount_percentage,
  } = data;

  // const checkSubmit = () => {
  //   setData((data) => ({
  //     ...data,
  //     base_fee_per_kilogram: base_fee_per_kilogram,
  //   }));
  //   handleSubmit();
  // };

  return (
    <div>
      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
        <div className="border-b border-[#E4E4F3] py-4 flex justify-between items-center mb-6">
          <h3 className="text-lg font-medium">Shipper Rates</h3>
        </div>
        <form name="form" id="shippers-form-rate2-edit">
          <div className="mb-8">
              <div className="border border-gray-300 py-2 px-2 mb-2">
                <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                  Discount Percentage (%) :
                </h3>
                <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                  This is a company's discount margin.
                </p>
              </div>
              <Input.Label
                title={"Discount Percentage"}
                value={discount_percentage}
                htmlFor={"discount_percentage"}
                name={"discount_percentage"}
                placeholder={"Enter discount percentage"}
                onChange={handleChange}
              />
              {submitted && !discount_percentage && (
                <div className="text-primary text-xs">
                  Discount rate is required
                </div>
              )}
            </div>

          <div className="mb-8">
            <div className="border border-gray-300 py-2 px-2 mb-2">
              <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                Maximum supported weight (Kg) :
              </h3>
              <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                The maximum supported weight per delivery depending on the category.
              </p>
            </div>
            <Input.Label
              title={"Maximum Weight"}
              htmlFor={"weight_limit_by_kilogram"}
              name={"weight_limit_by_kilogram"}
              placeholder={"Enter maximum weight"}
              value={weight_limit_by_kilogram}
              onChange={handleChange}
            />
            {submitted && !weight_limit_by_kilogram && (
              <div className="text-primary text-xs">
                Maximum weight is required
              </div>
            )}
          </div>
          <div className="mb-8">
            <div className="border border-gray-300 py-2 px-2 mb-2">
              <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                Charge per weight (1kg) :
              </h3>
              <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                This is the charge per weight of customer item depending on category.
              </p>
            </div>
            <Input.Label
              title={"Charge Per Weight"}
              htmlFor={"base_fee_per_kilogram"}
              name={"base_fee_per_kilogram"}
              placeholder={"NGN 500"}
              onChange={handleChange}
              defaultValue={base_fee_per_kilogram}
            />
            {submitted && !base_fee_per_kilogram && (
              <div className="text-primary text-xs">Charge is required</div>
            )}
          </div>
          <div className="mb-8">
            <div className="border border-gray-300 py-2 px-2 mb-2">
              <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                VAT Percentage (%) :
              </h3>
              <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                This is a company's VAT.
              </p>
            </div>
            <Input.Label
              title={"VAT Percentage"}
              htmlFor={"vat_percentage"}
              name={"vat_percentage"}
              placeholder={"Enter VAT percentage"}
              value={vat_percentage}
              onChange={handleChange}
            />
            {submitted && !vat_percentage && (
              <div className="text-primary text-xs">
                VAT percentage is required
              </div>
            )}
          </div>
        </form>
      </div>
      {/* <div className="flex justify-center mx-auto sm:mt-10">
        <Button.Primary
          type={"button"}
          title={updating ? <Beat color={"#ffffff"} /> : "Save Changes"}
          className={"w-[135px] rounded-sm"}
          onClick={checkSubmit}
        />
      </div> */}
    </div>
  );
}
